// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__BX6hD","socials":"Footer_socials__dQw74","social":"Footer_social__CLQqr","developer":"Footer_developer__P+wzd","dark":"Footer_dark__sBIfW"};